export default __webpack_public_path__ + "static/media/SamuraiShodown.f59c9385.jpg";